import SummaryBlocks from './SummaryBlocks';

export default SummaryBlocks;